import { LOCAL_STORAGE_OIDC_TOKEN_NAME } from '@constants';
import Layout from '@product-framework/components/Layout';
import { LoadingEvent, useDataProvider } from '@ui-framework/index';
import { GetDomain } from '@utils/index';
import { useEffect, useState } from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

function ApiDocumentation() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl, get } = useDataProvider(provider);

  const domain = GetDomain(process.env.REACT_APP_API_HOST, '', true);

  const getApiDocumentation = async () => {
    const apiUrl = `${getApiUrl()}/sxcl/v1/swagger`;
    try {
      const response = await get(apiUrl);
      return response.data;
    } catch (error) {
      return [];
    }
  };

  const initialize = async () => {
    setLoading(true);
    const response = await getApiDocumentation();
    if (response) {
      setDocuments(response);
    }
    setLoading(false);
  };
  useEffect(() => {
    initialize();
  }, []);

  return (
    <Layout>
      {loading ? (
        <LoadingEvent />
      ) : (
        documents && (
          <SwaggerUI
            spec={documents}
            docExpansion="none"
            defaultModelExpandDepth={2}
            defaultModelsExpandDepth={4}
            showExtensions
            showCommonExtensions
            supportedSubmitMethods={documents['x-supportedSubmitMethods'] || []}
            requestInterceptor={req => {
              const url = new URL(req.url);
              const path = url.pathname + url.search;
              req.url = `${domain}${path}`;
              const tokenName = window.localStorage.getItem(
                LOCAL_STORAGE_OIDC_TOKEN_NAME,
              );
              const sessionAuthData = tokenName
                ? window.localStorage.getItem(tokenName)
                : null;
              const token = sessionAuthData
                ? JSON.parse(sessionAuthData)?.access_token
                : null;
              if (token) {
                req.headers.Authorization = `Bearer ${token}`;
              }
              return req;
            }}
          />
        )
      )}
    </Layout>
  );
}
export default ApiDocumentation;
